export default __webpack_public_path__ + "static/media/September2021.2bbce97f.png";